module.exports = __webpack_public_path__ + "fonts/Extenda-40Hecto.e572e6e.woff";